const SearchCircleFilled = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.68514 2.61707C5.37599 2.61707 2.68384 5.30921 2.68384 8.61837C2.68384 11.9275 5.37599 14.6197 8.68514 14.6197C11.9943 14.6197 14.6865 11.9275 14.6865 8.61837C14.6865 5.30921 11.9943 2.61707 8.68514 2.61707ZM11.5392 11.4724C11.4454 11.5661 11.3183 11.6188 11.1857 11.6188C11.0531 11.6188 10.926 11.5661 10.8322 11.4724L9.49313 10.1337C8.92743 10.523 8.23668 10.6868 7.55642 10.593C6.87617 10.4992 6.25552 10.1546 5.81627 9.62674C5.37702 9.0989 5.15088 8.42597 5.18224 7.74C5.21359 7.05402 5.50016 6.40452 5.98573 5.91896C6.47129 5.43339 7.12079 5.14682 7.80677 5.11546C8.49275 5.08411 9.16568 5.31025 9.69351 5.7495C10.2213 6.18875 10.566 6.80939 10.6598 7.48965C10.7536 8.16991 10.5897 8.86066 10.2005 9.42636L11.5392 10.7654C11.6329 10.8592 11.6856 10.9863 11.6856 11.1189C11.6856 11.2515 11.6329 11.3787 11.5392 11.4724Z"
      fill="black"
    />
    <path
      d="M7.93542 9.61925C8.90252 9.61925 9.68651 8.83526 9.68651 7.86816C9.68651 6.90106 8.90252 6.11707 7.93542 6.11707C6.96832 6.11707 6.18433 6.90106 6.18433 7.86816C6.18433 8.83526 6.96832 9.61925 7.93542 9.61925Z"
      fill="black"
    />
  </svg>
);

export default SearchCircleFilled;
